export default __webpack_public_path__ + "static/media/ghana-cities-rubiks-dgray3.8c345a13.png";